import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { boApi, getToken, setToken } from "./api";

const Ctx = createContext(null);
export const useBo = () => useContext(Ctx);
const IDLE_MS = 30 * 60 * 1000;

export function BoAuthProvider({ children }) {
  const [admin, setAdmin] = useState(getToken() ? null : false);
  const timer = useRef(null);

  const logout = useCallback(async (silent) => {
    if (!silent && getToken()) await boApi.post("/auth/logout").catch(() => {});
    setToken(null);
    setAdmin(false);
  }, []);

  useEffect(() => {
    if (getToken()) boApi.get("/auth/me").then((r) => setAdmin(r.data)).catch(() => setAdmin(false));
    const h = () => setAdmin(false);
    window.addEventListener("bo-logout", h);
    return () => window.removeEventListener("bo-logout", h);
  }, []);

  useEffect(() => {
    if (!admin) return undefined;
    const reset = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => logout(), IDLE_MS);
    };
    const evs = ["mousemove", "keydown", "click", "scroll"];
    evs.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      clearTimeout(timer.current);
      evs.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [admin, logout]);

  const signedIn = (token, a) => {
    setToken(token);
    setAdmin(a);
  };
  const can = (p) => !!admin && admin.perms.includes(p);
  return <Ctx.Provider value={{ admin, signedIn, logout, can }}>{children}</Ctx.Provider>;
}
